<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-form label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="7">
            <!--留言时间-->
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.timeType">
                    <el-option
                      v-for="(item, index) in timeTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </template>
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale === 'zh' ? zhDate : ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!--运单编号-->
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.numberType">
                    <el-option
                      key="1"
                      :label="$t('GlobalSetObj.waybillNumber')"
                      :value="0"
                    /><!--运单号-->
                    <el-option
                      key="2"
                      :label="$t('GlobalSetObj.ScanNumber')"
                      :value="1"
                    /><!--扫描单号-->
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="returnWaybillNumber"
                :placeholder="$t('GlobalSetObj.CanBeEnteredMultiple2000')"
                :rows="1"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" style="width: auto">
            <div style="margin-top: 27px">
              <!--搜索-->
              <el-button
                size="small" type="primary" @click="enterSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <!--重置-->
              <el-button
                size="small" type="info" @click="resetForm()"
              >{{ $t('newOrder.reset') }}
              </el-button>
              <el-radio-group
                v-model="queryForm.params.testData"
                size="small"
                style="margin-left: 10px"
                @change="enterSearch"
              >
                <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button><!--正式-->
                <el-radio-button :label="2">{{ $t('newOrder.test1') }}</el-radio-button><!--测试-->
              </el-radio-group>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!--高级搜索-->
        <el-button
          size="small" type="primary" @click="advancedSearch"
        >{{ $t('home.advancedSearch') }}
        </el-button>
        <!--批量导入-->
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:bulkImport'"
          icon="el-icon-upload2"
          size="small"
          @click="allImportOrder"
        >{{ $t('newOrder.bulkImport') }}
        </el-button>
        <!--修改截止时间-->
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:fixTime'"
          size="small"
          @click="clickDeadline"
        >
          {{ $t('home.fixTime') }}
        </el-button>
        <!--修改处状态或结果-->
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:fixResult'"
          size="small"
          @click="clickFixResult"
        >
          {{ $t('home.fixResult') }}
        </el-button>
        <!--关闭-->
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:close'"
          icon="el-icon-circle-close"
          size="small"
          @click="closeOrder()"
        >
          {{ $t('GlobalSetObj.Close') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:export'"
          icon="el-icon-upload2"
          size="small"
          @click="exportOrder()"
        >
          {{ $t('navbar.export') }}
        </el-button>
        <!--   导出图片     -->
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:exportImage'"
          size="small"
          @click="exportOrderImage"
        >
          {{ $t('home.exportPicture') }}
        </el-button>
        <!--批量 导出 单号-->
        <el-button
          size="small" @click="orderNumberExport"
        >{{ $t('placeOrder.BatchExport') }}
        </el-button>

        <!-- 取消 -->
        <el-button
          v-permit:remove="'btn:complaintWorkOrder:cancel'"
          size="small"
          @click="cancelOrder"
        >
          {{ $t('GlobalSetObj.cancel') }}
        </el-button>
      </div>
      <!--  搜索提示    -->
      <el-row :gutter="20">
        <el-col :span="24" style="margin-top: 10px">
          <el-tag
            v-if="tipSearch.status"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(1)"
          >
            <span>{{ $t('GlobalSetObj.ProcessingStatus') }}: </span>
            <span>{{ tipSearch.status }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.result"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(2)"
          >
            <span>{{ $t('collectionCenter.processingResult') }}: </span>
            <span>{{ tipSearch.result }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.istimeOut"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(3)"
          >
            <span>{{ $t('orderCenterCont.TimeoutOrNot') }}: </span>
            <span>{{ tipSearch.istimeOut }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.customerName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(4)"
          >
            <span>{{ $t('GlobalSetObj.client') }}: </span>
            <span>{{ tipSearch.customerName }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.merchantName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(5)"
          >
            <span>{{ $t('placeOrder.CommercialOwner') }}: </span>
            <span>{{ tipSearch.merchantName }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.stateName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(6)"
          >
            <span>{{ $t('collectionCenter.stateSite1') }}: </span>
            <span>{{ tipSearch.stateName }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.siteName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(7)"
          >
            <span>{{ '网点' }}: </span>
            <span>{{ tipSearch.siteName }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.registerUserName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(8)"
          >
            <span>{{ $t('collectionCenter.registrar') }}: </span>
            <span>{{ tipSearch.registerUserName }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.complaintTypeName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(9)"
          >
            <span>{{ $t('tablePrice.complaintType') }}: </span>
            <span>{{ tipSearch.complaintTypeName }}</span>
          </el-tag>
          <el-tag
            v-if="tipSearch.workOrderTypeName"
            :disable-transitions="false"
            closable
            effect="dark"
            size="small"
            style="margin-right: 10px"
            type="info"
            @close="handleClose(10)"
          >
            <span>{{ $t('tablePrice.workOrderType') }}: </span>
            <span>{{ tipSearch.workOrderTypeName }}</span>
          </el-tag>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card" style="margin-top: 10px">
      <el-tabs v-model="activeName" style="margin-top: -10px" @tab-click="handleClick">
        <el-tab-pane name="-1">
          <span slot="label">
            {{ $t('GlobalSetObj.all') }} {{ getOrderTypeTotalDataRes.total }}
          </span>
        </el-tab-pane>
        <el-tab-pane
          :disabled="getOrderTypeTotalDataRes.falseSignTotal === 0" name="1"
        ><span slot="label">
          {{ $t('compensationManagement.FalseSigningForDelivery') }}
          {{ getOrderTypeTotalDataRes.falseSignTotal }}</span>
        </el-tab-pane>
        <el-tab-pane
          :disabled="getOrderTypeTotalDataRes.suspectedLossTotal === 0" name="0"
        ><span slot="label">
          {{ $t('operationTips.yisiLost') }} {{ getOrderTypeTotalDataRes.suspectedLossTotal }}
        </span></el-tab-pane>
        <el-tab-pane
          :disabled="getOrderTypeTotalDataRes.missingTotal === 0" name="2"
        ><span slot="label">
          {{ $t('compensationManagement.wrongOrMissingItems') }}
          {{ getOrderTypeTotalDataRes.missingTotal }}
        </span>
        </el-tab-pane>
        <el-tab-pane
          :disabled="getOrderTypeTotalDataRes.damagedTotal === 0" name="3"
        ><span slot="label">
          {{ $t('compensationManagement.damagedItems') }}
          {{ getOrderTypeTotalDataRes.damagedTotal }}
        </span>
        </el-tab-pane>
        <!--商业投诉-->
        <el-tab-pane
          :disabled="getOrderTypeTotalDataRes.businessComplainTotal === 0" name="4"
        ><span slot="label">
          {{ $t('compensationManagement.CommercialComplaint') }}
          {{ getOrderTypeTotalDataRes.businessComplainTotal }}
        </span>
        </el-tab-pane>
      </el-tabs>
      <!--  表格数据  -->
      <el-table
        ref="tableRef"
        :data="tableData"
        border
        height="520"
        row-key="id"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- 序列号/复选框 -->
        <el-table-column
          align="center" fixed="left" type="selection"
          width="50"
        />
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          type="index"
          width="70"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.align"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--处理状态-->
            <div v-if="item.prop === 'processingState'">
              <el-tag
                v-if="scope.row[item.prop] === 0" size="small" type="success"
              >{{ $t('GlobalSetObj.Pending') }}
                <!--待处理-->
              </el-tag>
              <el-tag
                v-else-if="scope.row[item.prop] === 1" size="small"
              >{{ $t('newOrder.processing') }}
                <!--处理中-->
              </el-tag>
              <el-tag
                v-else-if="scope.row[item.prop] === 2" size="small" type="warning"
              >{{ $t('collectionCenter.closedLoop') }}
                <!--已闭环-->
              </el-tag>
              <el-tag
                v-else-if="scope.row[item.prop] === 3" size="small" type="danger"
              >{{ $t('collectionCenter.cancelled') }}
                <!--已取消-->
              </el-tag>
            </div>
            <!--是否有回复-->
            <div v-else-if="item.prop === 'isLastReply'">
              <div v-if="scope.row.processingState === 2">-</div>
              <div v-else>
                <el-tag
                  v-if="scope.row[item.prop] === 0" size="small" type="info"
                >{{ $t('GlobalSetObj.No') }}
                  <!--否-->
                </el-tag>
                <el-tag
                  v-else-if="scope.row[item.prop] === 1" size="small" type="success"
                >{{ $t('GlobalSetObj.yes') }}
                  <!--是-->
                </el-tag>
                <div v-else-if="!scope.row[item.prop]">-</div>
              </div>
            </div>
            <!--是否超时-->
            <div v-else-if="item.prop === 'isTimeOut'">
              <el-tag
                v-if="scope.row[item.prop] === 0" size="small" type="info"
              >{{ $t('GlobalSetObj.No') }}
                <!--否-->
              </el-tag>
              <el-tag
                v-else-if="scope.row[item.prop] === 1" size="small" type="success"
              >{{ $t('GlobalSetObj.yes') }}
                <!--是-->
              </el-tag>
            </div>
            <div v-else-if="item.prop === 'lastReplyContent'">
              <div
                v-if="
                  scope.row[item.prop] !== null &&
                    scope.row[item.prop] !== '' &&
                    scope.row[item.prop] !== undefined
                "
              >
                <div class="tableImg" v-html="scope.row[item.prop]" />
              </div>
              <div v-else>-</div>
            </div>
            <div v-else>
              <div>{{ scope.row[item.prop] || '--' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newOrder.operation')" align="center" fixed="right"
          width="120"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.processingState !== 3"
              style="display: flex; justify-content: space-around; align-items: center"
            >
              <!--回复-->
              <el-tooltip
                v-permit:remove="'btn:complaintWorkOrder:Reply'"
                :content="$t('GlobalSetObj.Reply')"
                class="item"
                effect="dark"
                placement="top"
              >
                <i
                  class="iconfont icon-chakantiezihuifu textOperator2"
                  @click="replyMessage(scope.row)"
                />
              </el-tooltip>
              <!--关闭-->
              <el-tooltip
                v-if="scope.row.processingState !== 2"
                v-permit:remove="'btn:complaintWorkOrder:close'"
                :content="$t('GlobalSetObj.Close')"
                class="item"
                effect="dark"
                placement="top"
              >
                <i class="el-icon-circle-close textOperator" @click="closeOrder(scope.row)" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--回复弹窗-->
    <el-drawer
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :title="$t('GlobalSetObj.CommunicationContent')"
      :visible.sync="seeDialogVisible"
      class="drawerClass"
      direction="ltr"
      size="1000px"
      @close="closeDrawer"
    >
      <messageDetail ref="messageDetail" :reply-message-data="replyMessageData" />
    </el-drawer>
    <!-- 批量导入 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('basicData.BulkImport')"
      :visible.sync="importForm.messageRemrkDialog"
      width="500px"
      @close="closeDialog"
    >
      <div class="remarkBox">
        <el-form
          :key="importForm.messageRemrkDialog"
          ref="importForm"
          :model="importForm"
          label-position="top"
        >
          <el-form-item prop="importNumberType">
            <el-select v-model="importForm.importNumberType" style="width: 100%">
              <el-option
                key="1"
                :label="$t('GlobalSetObj.waybillNumber')"
                :value="0"
              /><!--运单号-->
              <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="1" /><!--扫描单号-->
            </el-select>
          </el-form-item>
          <el-form-item
            :rules="{
              required: true,
              message: $t('GlobalSetObj.pleaseInput'),
              trigger: ['blur', 'change']
            }"
            prop="importNumber"
          >
            <el-input
              v-model="importForm.importNumber"
              :placeholder="$t('receivablePayable.MultipleNumberWrapEntry')"
              :rows="6"
              type="textarea"
            />
          </el-form-item>
          <el-form-item
            :label="$t('tablePrice.workOrderType')"
            :rules="{
              required: true,
              message: $t('GlobalSetObj.pleaseInput'),
              trigger: ['blur', 'change']
            }"
            prop="workOrderType"
          >
            <el-select v-model="importForm.workOrderType" style="width: 100%">
              <el-option
                key="0"
                :label="$t('compensationManagement.FalseSigningForDelivery')"
                :value="1"
              /><!--虚假签收-->
              <el-option
                key="1"
                v-permit:remove="'btn:complaintWorkOrder:orSign'"
                :label="$t('operationTips.yisiLost')"
                :value="0"
              /><!-- 虚假签收 -->
              <el-option
                key="2"
                :label="$t('compensationManagement.wrongOrMissingItems')"
                :value="2"
              /><!--错漏件-->
              <el-option
                key="3"
                :label="$t('compensationManagement.damagedItems')"
                :value="3"
              /><!--  破损件  -->
              <el-option
                key="3"
                :label="$t('compensationManagement.CommercialComplaint')"
                :value="4"
              /><!--  商业投诉  -->
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="importForm.workOrderType === 1"
            :label="$t('tablePrice.complaintType')"
            prop="complaintType"
            :rules="{
              required: true,
              message: $t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
          >
            <el-radio-group v-model="importForm.complaintType">
              <el-radio :label="0">{{ $t('tablePrice.consumerComplaint') }}</el-radio>
              <el-radio :label="1">{{ $t('tablePrice.platformComplaint') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--选择处理网点-->
          <el-form-item
            :label="$t('tablePrice.SelectProcessingHub')"
            prop="siteType"
            :rules="{
              required: true,
              message: $t('GlobalSetObj.pleaseChoose'),
              trigger: ['blur', 'change']
            }"
          >
            <el-radio-group v-model="importForm.siteType">
              <el-radio
                v-permit:remove="'btn:complaintWorkOrder:bulkImport'"
                :label="1"
              >{{ $t('tablePrice.ActualDeliveryHub') }}</el-radio>
              <el-radio
                v-permit:remove="'btn:complaintWorkOrder:headOffice'"
                :label="2"
              >{{ $t('collectionCenter.headOffice') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="messageRemarkSubmit(1)"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="messageRemarkSubmit(2)">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!--导入结果-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('GlobalSetObj.ImportResults')"
      :visible.sync="resultData.showImportResults"
      width="710px"
    >
      <div class="remarkBox">
        <div style="display: flex">
          <div style="width: 220px">
            <!--总共导入-->
            {{ $t('receivablePayable.TotalImport') }}：<span style="color: #409eff">{{
              resultData.all
            }}</span>
          </div>
          <div style="flex: 1">
            <!--导入成功-->
            {{ $t('orderCenterCont.ImportWasSuccessful') }}：{{ resultData.success }}
          </div>
          <div style="width: 220px">
            <!--导入失败-->
            {{ $t('orderCenterCont.ImportFailed') }}：<span style="color: red">{{
              resultData.err
            }}</span>
          </div>
        </div>
        <div v-if="resultData.err > 0">
          <!--导入失败原因-->
          <div style="margin: 20px 0 0 0">{{ $t('GlobalSetObj.ReasonForFailure') }}</div>
          <div style="max-height: 310px; overflow-y: auto">
            <div v-for="(item, index) in resultData.errData" :key="index" style="margin-top: 10px">
              <span>{{ index }}：{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="resultData.showImportResults = false">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 关闭投诉 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.processingResult')"
      :visible.sync="closeReturn.showCloseComplaints"
      width="500px"
      @close="closeReturnSubmit(1)"
    >
      <div class="remarkBox">
        <div style="margin: 20px 0">
          {{ $t('GlobalSetObj.totalOptions') }}：{{ closeReturn.selectedNum }}
        </div>
        <el-form :key="closeReturn.showCloseComplaints" ref="closeReturn" :model="closeReturn">
          <el-form-item
            :label="$t('collectionCenter.processingResult') + '：'"
            :rules="{
              required: true,
              message: $t('GlobalSetObj.pleaseChoose'),
              trigger: ['change', 'blur']
            }"
            prop="processingResult"
          >
            <el-select
              v-model="closeReturn.processingResult"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in processingResultList01"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="closeReturnSubmit(1)"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="closeReturnSubmit(2)">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改截止时间 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('home.fixTime')"
      :visible.sync="changeDeadline"
      width="500px"
    >
      <div style="margin-bottom: 40px">
        <el-date-picker
          v-model="time01"
          :placeholder="$t('order.orderDatePlaceholder')"
          type="date"
          value-format="yyyy-MM-dd"
        />
        <el-time-picker
          v-model="time02"
          :placeholder="$t('base.selectTime')"
          style="margin-left: 30px"
          value-format="HH:mm:ss"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="changeDeadline = false"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="confirmUpdataDeadline">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改处理结果 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('home.fixResult')"
      :visible.sync="modifyingResultDialog"
      width="500px"
      @close="submitModifyingResult(1)"
    >
      <div class="remarkBox">
        <div style="margin: 10px 0; color: black">
          {{ $t('GlobalSetObj.totalOptions') }}：<span style="color: red">{{
            modifyingResult.selectedNum
          }}</span>
        </div>
        <div class="selectLabel" style="margin-bottom: 5px">
          <el-select
            v-model="modifyingResult.updateType"
            style="width: 170px"
            @change="changeResultType"
          >
            <el-option :key="1111" :label="$t('home.modifyStatus')" :value="0" />
            <el-option :key="2222" :label="$t('home.modifyResult')" :value="1" />
          </el-select>
        </div>
        <el-select
          v-model="modifyingResult.updateProcessingResult"
          :placeholder="$t('GlobalSetObj.pleaseChoose')"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in fixList"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="submitModifyingResult(1)"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="submitModifyingResult(2)">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改结果 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="tipDialog"
      width="550px"
    >
      <div>
        <div class="flx-between">
          <div>
            <span>{{ $t('home.operationTotal') }}：</span>
            <span>{{ tipObj.totalNumber }}</span>
          </div>
          <div>
            <span>{{ $t('operationCenter.NumberOfSuccesses') }}：</span>
            <span>{{ tipObj.succeedNumber }}</span>
          </div>
          <div>
            <span>{{ $t('operationCenter.NumberOfFailures') }}：</span>
            <span style="color: red">{{ tipObj.failNumber }}</span>
          </div>
        </div>
        <div v-if="tipObj.failNumber" style="height: 200px; overflow-y: auto">
          <div style="margin-top: 20px; margin-bottom: 8px">
            {{ $t('GlobalSetObj.ReasonForFailure') }}:
          </div>
          <div v-for="(key, val, index) in tipObj.failMap" :key="key">
            <span>{{ index + 1 }}. </span>
            <span>{{ key }}: </span>
            <span>{{ val }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          size="small" type="primary" @click="tipDialog = false"
        >{{ $t('GlobalSetObj.Close') }}
        </el-button>
      </div>
    </el-dialog>
    <!--  高级搜索  -->
    <searchCom ref="searchComRef" @child-event01="parentMethod01" />
    <!--  导出图片  -->
    <exportImage ref="exportImageRef" />
    <!--  批量单号导出 -->
    <exportOrderNumber ref="exportOrderNumberRef" />

    <!-- 取消工单——提醒 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('collectionCenter.alert')"
      :visible.sync="closeCancelDialog"
      width="350px"
      @close="cancelDialogClose"
    >
      <div style="padding-left: 20px; box-sizing: border-box">
        <!-- 确定要取消这些工单吗？ -->
        <p style="font-size: 16px">{{ $t('collectionCenter.confirmCancelTickets') }}</p>
        <!-- 取消后不可恢复。 -->
        <p style="font-size: 16px">{{ $t('collectionCenter.cancelIrreversible') }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="cancelDialogClose"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button size="small" type="primary" @click="cancelSubmit">
          {{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 取消工单——操作结果 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('operationCenter.TheResultOfTheOperation')"
      :visible.sync="closeOperationResultDialog"
      width="30%"
      @close="operationResultDialogClose"
    >
      <div>
        <el-row
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <el-col :span="7">
            <!--  操作总数  -->
            <span
              style="text-align: left"
            >{{ $t('home.operationTotal') }}：{{ cancelResult.totalCount }}</span>
          </el-col>
          <el-col :span="7">
            <!--  成功数  -->
            <span
              style="text-align: left"
            >{{ $t('Resource.successCount') }}：{{ cancelResult.successCount }}</span>
          </el-col>
          <el-col :span="7">
            <!--  失败数  -->
            <span
              style="text-align: left"
            >{{ $t('GlobalSetObj.FailureCount') }}：<span style="color: #e02f45">{{
              cancelResult.failCount
            }}</span></span>
          </el-col>
        </el-row>
        <div v-for="(item, idx) in cancelResult.failReasonList" :key="idx">
          {{ idx + 1 }}. {{ item.waybillNumber }}，{{ item.reason }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelConfirm">{{ $t('GlobalSetObj.confirm') }} </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {
  apiGetComplaintWorkCloseWork,
  apiGetComplaintWorkOrderImport,
  apiGetComplaintWorkOrderPage,
  complaintWorkOrderCancel,
  complaintWorkOrderExport,
  getOrderTypeTotal,
  updateDeadline,
  updateResult
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
import {
  complaintSourceObj,
  complaintStatusObj,
  complaintTypeObj,
  processingResultObj
} from '@/utils/enumData';
import $i18n from '@/lang';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'ComplaintWorkOrder',
  components: {
    messageDetail: () => import('./messageDetail.vue'),
    searchCom: () => import('./component/searchCom.vue'),
    exportImage: () => import('./component/exportImage.vue'),
    exportOrderNumber: () => import('./component/exportOrderNumber.vue')
  },
  data() {
    return {
      cancelResult: {},
      cancelIdList: [],
      closeOperationResultDialog: false,
      closeCancelDialog: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      returnWaybillNumber: '', // 运单号
      // 导入结果提示
      resultData: {
        showImportResults: false,
        all: 0,
        success: 0,
        err: 0,
        errData: []
      },
      // 批量导入
      importForm: {
        messageRemrkDialog: false,
        importNumberType: 0,
        importNumber: '',
        complaintType: 0,
        workOrderType: '',
        siteType: 1
      },
      // 处理结果
      closeReturn: {
        showCloseComplaints: false,
        selectedNum: 0, // 选择的数据数量
        processingResult: null // 处理结果
      },
      seeDialogVisible: false,
      tableData: [],
      tableHeaderList: [
        // 运单号
        {
          label: this.$t('GlobalSetObj.waybillNumber'),
          prop: 'waybillNumber',
          cloWidth: '180',
          align: 'center'
        },
        // 扫描单号
        {
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanNumber',
          cloWidth: '180',
          align: 'center'
        },
        // 投诉类型
        {
          label: this.$t('tablePrice.workOrderType'),
          prop: 'workOrderTypeName',
          cloWidth: '180',
          align: 'center'
        },
        // 投诉来源
        {
          label: this.$t('tablePrice.complaintType'),
          prop: 'complaintTypeName',
          cloWidth: '180',
          align: 'center'
        },
        // 处理状态
        {
          label: this.$t('GlobalSetObj.ProcessingStatus'),
          prop: 'processingState',
          cloWidth: '180',
          align: 'center'
        },
        // 处理结果
        {
          label: this.$t('collectionCenter.processingResult'),
          prop: 'processingResultName',
          cloWidth: '180',
          align: 'center'
        },
        // 定责人
        {
          label: this.$t('fixDutyFine.DefinitePerson'),
          prop: 'closerName',
          cloWidth: '160',
          align: 'center'
        },
        // 登记时间
        {
          label: this.$t('collectionCenter.RegistrationT'),
          prop: 'registerTime',
          cloWidth: '180',
          align: 'center'
        },
        // 是否有最新回复
        {
          label: this.$t('GlobalSetObj.HasReply'),
          prop: 'isLastReply',
          cloWidth: '150',
          align: 'center'
        },
        // 最新回复时间
        {
          label: this.$t('GlobalSetObj.newReplyTime'),
          prop: 'lastReplyTime',
          cloWidth: '180',
          align: 'center'
        },
        // 最新回复内容
        {
          label: this.$t('GlobalSetObj.LatestReplyContent'),
          prop: 'lastReplyContent',
          cloWidth: '225',
          align: 'center'
        },
        // 客户
        {
          label: this.$t('GlobalSetObj.client'),
          prop: 'customerName',
          cloWidth: '180',
          align: 'center'
        },
        // 商户
        {
          label: this.$t('collectionCenter.CommercialOwner'),
          prop: 'merchantName',
          cloWidth: '180',
          align: 'center'
        },
        // 截止时间
        {
          label: this.$t('GlobalSetObj.Deadline'),
          prop: 'abortTime',
          cloWidth: '180',
          align: 'center'
        },
        // 闭环时间
        {
          label: this.$t('driver.closedLoopTime'),
          prop: 'closedLoopTime',
          cloWidth: '180',
          align: 'center'
        },
        // 是否超时
        {
          label: this.$t('orderCenterCont.TimeoutOrNot'),
          prop: 'isTimeOut',
          cloWidth: '180',
          align: 'center'
        },
        // 大区 Região
        {
          label: this.$t('collectionCenter.region'),
          prop: 'regionName',
          cloWidth: '100',
          align: 'center'
        },
        // 网点所属州
        {
          label: this.$t('collectionCenter.stateSite1'),
          prop: 'state',
          cloWidth: '180',
          align: 'center'
        },
        // 网点名称
        {
          label: this.$t('collectionCenter.siteName'),
          prop: 'siteName',
          cloWidth: '180',
          align: 'center'
        },
        // 登记人
        {
          label: this.$t('collectionCenter.registrar'),
          prop: 'registerUserName',
          cloWidth: '180',
          align: 'center'
        },
        // 最新处理人
        {
          label: this.$t('GlobalSetObj.LatestProcessor'),
          prop: 'newOptionUserName',
          cloWidth: '180',
          align: 'center'
        },
        // 最新处时间
        {
          label: this.$t('GlobalSetObj.LatestProcessingTime'),
          prop: 'newOptionTime',
          cloWidth: '180',
          align: 'center'
        }
      ],
      selectData: [],
      closeData: [],
      replyMessageData: null,
      changeDeadline: false,
      time01: '',
      time02: '',
      modifyingResultDialog: false,
      modifyingResult: {
        updateProcessingResult: '',
        selectedNum: '',
        updateType: 0
      },
      tipObj: {
        failList: []
      },
      tipDialog: false,
      processingResultList01: [
        { label: $i18n.t('GlobalSetObj.blameless'), value: 1 },
        { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 0 },
        // 需求：应客服部要求，关闭按钮去掉【全部丢失】的选项。
        // { label: $i18n.t('compensationManagement.lossOfAll'), value: 2 },
        { label: $i18n.t('compensationManagement.PartiallyLost'), value: 3 },
        { label: $i18n.t('home.goodsNOfuhe'), value: 5 },
        { label: $i18n.t('home.infoError'), value: 6 },
        { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
        { label: $i18n.t('tablePrice.invalidResponse'), value: 8 },
        { label: $i18n.t('tablePrice.confirmedLost'), value: 10 },
        { label: $i18n.t('compensationManagement.trackingUpdated'), value: 11 },
        { label: $i18n.t('compensationManagement.established'), value: 12 },
        { label: $i18n.t('compensationManagement.notEstablished'), value: 13 }
      ],
      timeTypeList: [
        {
          label: this.$t('collectionCenter.RegistrationT'),
          value: 1
        },
        {
          label: this.$t('GlobalSetObj.newReplyTime'),
          value: 2
        },
        {
          label: this.$t('GlobalSetObj.Deadline'),
          value: 3
        },
        {
          label: this.$t('driver.closedLoopTime'),
          value: 4
        }
      ],
      searchParams: {},
      tipSearch: {
        status: '',
        result: '',
        istimeOut: '',
        customerName: '',
        merchantName: '',
        stateName: '',
        siteName: '',
        registerUserName: '',
        complaintTypeName: '',
        workOrderTypeName: ''
      },
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          waybillNumberList: [], // 运单号
          scanNumberList: [], // 扫描单号
          numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
          timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
          testData: 1 // 1:正式 2:测试
        }
      },
      fixList: [
        { label: this.$t('GlobalSetObj.Pending'), value: 0 }, // 待处理
        { label: this.$t('newOrder.processing'), value: 1 }, // 处理中
        { label: this.$t('collectionCenter.closedLoop'), value: 2 }, // 已闭环
        { label: this.$t('collectionCenter.cancelled'), value: 3 } // 已取消
      ],
      activeName: '-1',
      getOrderTypeTotalDataRes: {}
    };
  },
  created() {
    this.getTimer(); // 默认时间
    this.getSearch(); // 查询投诉列表
  },
  methods: {
    cancelOrder() {
      if (this.selectData.length <= 0) {
        this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
        return;
      }

      this.cancelIdList = this.selectData.map((item) => item.id);
      this.closeCancelDialog = true;
    },
    cancelDialogClose() {
      this.cancelIdList = [];
      this.closeCancelDialog = false;
      this.$refs.tableRef.clearSelection();
    },
    cancelSubmit() {
      const submitForm = {
        idList: this.cancelIdList
      };
      complaintWorkOrderCancel(submitForm).then((res) => {
        if (res.code === 200) {
          this.cancelResult = res.data;
          this.closeCancelDialog = false;
          this.closeOperationResultDialog = true;
        }
      });
    },
    operationResultDialogClose() {
      this.cancelResult = {};
      this.closeOperationResultDialog = false;
      this.getSearch();
    },
    cancelConfirm() {
      this.operationResultDialogClose();
    },
    handleClick(val) {
      console.log(val.name, 'handleClick');
      let flag = -1;
      if (Number(val.name) >= 0) {
        flag = Number(val.name);
      }
      this.queryForm.pageNumber = 1;
      this.getSearch(flag); // 查询投诉列表
    },
    // 切换投诉结果
    changeResultType(val) {
      this.modifyingResult.updateProcessingResult = '';
      if (val === 0) {
        this.fixList = [
          { label: this.$t('GlobalSetObj.Pending'), value: 0 }, // 待处理
          { label: this.$t('newOrder.processing'), value: 1 }, // 处理中
          { label: this.$t('collectionCenter.closedLoop'), value: 2 }, // 已闭环
          { label: this.$t('collectionCenter.cancelled'), value: 3 } // 已取消
        ];
      } else {
        this.fixList = [
          { label: $i18n.t('GlobalSetObj.blameless'), value: 1 },
          { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 0 },
          // 需求：应客服部要求，关闭按钮去掉【全部丢失】的选项。
          // { label: $i18n.t('compensationManagement.lossOfAll'), value: 2 },
          { label: $i18n.t('compensationManagement.PartiallyLost'), value: 3 },
          { label: $i18n.t('home.goodsNOfuhe'), value: 5 },
          { label: $i18n.t('home.infoError'), value: 6 },
          { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
          { label: $i18n.t('tablePrice.invalidResponse'), value: 8 },
          { label: $i18n.t('tablePrice.confirmedLost'), value: 10 },
          { label: $i18n.t('compensationManagement.trackingUpdated'), value: 11 },
          { label: $i18n.t('compensationManagement.established'), value: 12 },
          { label: $i18n.t('compensationManagement.notEstablished'), value: 13 }
        ];
      }
    },
    // 导出
    getOrderTypeTotalData() {
      const data = {
        waybillNumberList: [], // 运单号
        scanNumberList: [], // 扫描单号
        numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
        timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
        testData: this.queryForm.params.testData, // 1:正式 2:测试
        registerTime: null, // 登记时间开始
        registerTimeEnd: null, // 登记时间结束
        newReplyTime: null, // 最新回复时间开始
        newReplyTimeEnd: null, // 最新回复时间结束
        abortTime: null,
        abortTimeEnd: null,
        closedLoopStartTime: null,
        closedLoopEndTime: null
      };
      if (this.searchParams && Object.keys(this.searchParams).length) {
        Object.assign(data, this.searchParams);
      }
      let orderNumArr = [];
      if (this.returnWaybillNumber) {
        orderNumArr = this.returnWaybillNumber.split('\n');
      }
      if (this.queryForm.params.numberType === 0) {
        data.waybillNumberList = orderNumArr;
      } else {
        data.scanNumberList = orderNumArr;
      }
      if (orderNumArr.length > 2000) {
        this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.timeType === 1) {
          data.registerTime = this.timeValue[0];
          data.registerTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 2) {
          data.newReplyTime = this.timeValue[0];
          data.newReplyTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 3) {
          data.abortTime = this.timeValue[0];
          data.abortTimeEnd = this.timeValue[1];
        } else {
          data.closedLoopStartTime = this.timeValue[0];
          data.closedLoopEndTime = this.timeValue[1];
        }
      } else {
        if (orderNumArr.length === 0) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      getOrderTypeTotal(data).then((res) => {
        this.getOrderTypeTotalDataRes = res.data;
      });
    },
    // 查询
    getSearch(val = -1) {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          waybillNumberList: [], // 运单号
          scanNumberList: [], // 扫描单号
          numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
          timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
          testData: this.queryForm.params.testData, // 1:正式 2:测试
          registerTime: null, // 登记时间开始
          registerTimeEnd: null, // 登记时间结束
          newReplyTime: null, // 最新回复时间开始
          newReplyTimeEnd: null, // 最新回复时间结束
          abortTime: null,
          abortTimeEnd: null,
          closedLoopStartTime: null,
          closedLoopEndTime: null
        }
      };
      if (Object.keys(this.searchParams).length) {
        Object.assign(data.params, this.searchParams);
      }
      const orderNumArr = [];
      if (this.returnWaybillNumber) {
        // 分段去空格
        const arr = this.returnWaybillNumber.split(/[(\r\n)\r\n]+/);
        arr.map((item) => {
          if (item) {
            orderNumArr.push(item.trim());
          }
        });
      }
      if (this.queryForm.params.numberType === 0) {
        data.params.waybillNumberList = orderNumArr;
      } else {
        data.params.scanNumberList = orderNumArr;
      }
      if (orderNumArr.length > 2000) {
        this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.timeType === 1) {
          data.params.registerTime = this.timeValue[0];
          data.params.registerTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 2) {
          data.params.newReplyTime = this.timeValue[0];
          data.params.newReplyTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 3) {
          data.params.abortTime = this.timeValue[0];
          data.params.abortTimeEnd = this.timeValue[1];
        } else {
          data.params.closedLoopStartTime = this.timeValue[0];
          data.params.closedLoopEndTime = this.timeValue[1];
        }
      } else {
        if (orderNumArr.length === 0) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      if (val >= 0) {
        data.params.workOrderType = val;
      } else {
        this.activeName = '-1';
        this.getOrderTypeTotalData();
      }
      apiGetComplaintWorkOrderPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          const removeHtmlTags = (html) => {
            return html.replace(/<[^>]*>/g, '');
          };
          res.data.records.forEach((item) => {
            if (item.lastReplyContent) {
              item.lastReplyContent = removeHtmlTags(item.lastReplyContent);
            }
            if (item.processingResult !== null) {
              item.processingResultName = processingResultObj[item.processingResult];
            } else {
              item.processingResultName = '--';
            }
            if (item.workOrderType !== null) {
              item.workOrderTypeName = complaintTypeObj[item.workOrderType];
            }
            if (item.complaintType !== null) {
              item.complaintTypeName = complaintSourceObj[item.complaintType];
            }
          });
          this.tableData = res.data.records;
        }
      });
    },
    // 导出
    exportOrder() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          waybillNumberList: [], // 运单号
          scanNumberList: [], // 扫描单号
          numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
          timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
          testData: this.queryForm.params.testData, // 1:正式 2:测试
          registerTime: null, // 登记时间开始
          registerTimeEnd: null, // 登记时间结束
          newReplyTime: null, // 最新回复时间开始
          newReplyTimeEnd: null, // 最新回复时间结束
          abortTime: null,
          abortTimeEnd: null,
          closedLoopStartTime: null,
          closedLoopEndTime: null
        }
      };
      if (this.searchParams && Object.keys(this.searchParams).length) {
        Object.assign(data.params, this.searchParams);
      }
      let orderNumArr = [];
      if (this.returnWaybillNumber) {
        orderNumArr = this.returnWaybillNumber.split('\n');
      }
      if (this.queryForm.params.numberType === 0) {
        data.params.waybillNumberList = orderNumArr;
      } else {
        data.params.scanNumberList = orderNumArr;
      }
      if (orderNumArr.length > 2000) {
        this.$message.warning(this.$t('orderCenterCont.queried2000pieces'));
        return;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        if (this.queryForm.params.timeType === 1) {
          data.params.registerTime = this.timeValue[0];
          data.params.registerTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 2) {
          data.params.newReplyTime = this.timeValue[0];
          data.params.newReplyTimeEnd = this.timeValue[1];
        } else if (this.queryForm.params.timeType === 3) {
          data.params.abortTime = this.timeValue[0];
          data.params.abortTimeEnd = this.timeValue[1];
        } else {
          data.params.closedLoopStartTime = this.timeValue[0];
          data.params.closedLoopEndTime = this.timeValue[1];
        }
      } else {
        if (orderNumArr.length === 0) {
          this.$message.warning(this.$t('collectionCenter.PleaseSelectTime'));
          return;
        }
      }
      complaintWorkOrderExport(data).then(() => {
        goResourceTaskList();
      });
    },
    parentMethod01(arg) {
      console.log(arg, 'parentMethod01parentMethod01');
      this.searchParams = cloneDeep(arg);
      const arrState = [];
      if (arg.processingStateList && arg.processingStateList.length) {
        arg.processingStateList.forEach((item) => {
          arrState.push(complaintStatusObj[item]);
        });
      }
      const arrResult = [];
      if (arg.processingResult && arg.processingResult.length) {
        arg.processingResult.forEach((item) => {
          arrResult.push(processingResultObj[item]);
        });
      }
      this.tipSearch.status = arrState.join(',');
      this.tipSearch.result = arrResult.join(',');
      if (arg.istimeOut !== '' && arg.istimeOut !== null && arg.istimeOut !== undefined) {
        this.tipSearch.istimeOut = arg.istimeOut
          ? this.$t('GlobalSetObj.yes')
          : this.$t('GlobalSetObj.No');
      } else {
        this.tipSearch.istimeOut = '';
      }
      if (arg.customerName) {
        this.tipSearch.customerName = arg.customerName.join(',');
      } else {
        this.tipSearch.customerName = '';
      }
      if (arg.merchantName && arg.merchantName.length) {
        this.tipSearch.merchantName = arg.merchantName.join(',');
      } else {
        this.tipSearch.merchantName = '';
      }
      if (arg.state && arg.state.length) {
        this.tipSearch.stateName = arg.state.join(',');
      } else {
        this.tipSearch.stateName = '';
      }
      if (arg.state && arg.siteName.length) {
        this.tipSearch.siteName = arg.siteName.join(',');
      } else {
        this.tipSearch.siteName = '';
      }
      if (arg.registerUserName) {
        this.tipSearch.registerUserName = arg.registerUserName.join(',');
      } else {
        this.tipSearch.registerUserName = '';
      }
      if (
        arg.complaintType !== '' &&
        arg.complaintType !== null &&
        arg.complaintType !== undefined
      ) {
        this.tipSearch.complaintTypeName = complaintSourceObj[arg.complaintType];
      } else {
        this.tipSearch.complaintTypeName = '';
      }
      if (
        arg.workOrderType !== '' &&
        arg.workOrderType !== null &&
        arg.workOrderType !== undefined
      ) {
        this.tipSearch.workOrderTypeName = complaintTypeObj[arg.workOrderType];
      } else {
        this.tipSearch.workOrderTypeName = '';
      }
      this.getSearch();
    },
    // 点击高级搜索
    advancedSearch() {
      const hasAnyValue = this.hasValue(this.tipSearch);
      console.log(hasAnyValue, 'hasAnyValuehasAnyValue', this.searchParams);
      this.$refs.searchComRef.showDialog(hasAnyValue, this.searchParams);
    },
    // 要判断 tipSearch 对象中的任意一个属性是否有值
    hasValue(obj) {
      for (const key in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(key) && obj[key]) {
          return true;
        }
      }
      return false;
    },
    handleClose(val) {
      if (val === 1) {
        this.tipSearch.status = '';
        this.searchParams.processingStateList = [];
      } else if (val === 2) {
        this.tipSearch.result = '';
        this.searchParams.processingResult = [];
      } else if (val === 3) {
        this.tipSearch.istimeOut = '';
        this.searchParams.istimeOut = null;
      } else if (val === 4) {
        this.tipSearch.customerName = '';
        this.searchParams.customerId = [];
        this.searchParams.customerName = [];
      } else if (val === 5) {
        this.tipSearch.merchantName = '';
        this.searchParams.merchantName = [];
      } else if (val === 6) {
        this.tipSearch.stateName = '';
        this.searchParams.state = [];
      } else if (val === 7) {
        this.tipSearch.siteName = '';
        this.searchParams.siteName = [];
      } else if (val === 8) {
        this.tipSearch.registerUserName = '';
        this.searchParams.registerUserId = [];
        this.searchParams.registerUserName = [];
      } else if (val === 9) {
        this.tipSearch.complaintTypeName = '';
        this.searchParams.complaintType = null;
      } else if (val === 10) {
        this.tipSearch.workOrderTypeName = '';
        this.searchParams.workOrderType = null;
      }
      this.queryForm.pageNumber = 1;
    },
    // 点击修改处理结果
    clickFixResult() {
      if (this.selectData.length) {
        const arr = [];
        this.selectData.forEach((item) => {
          if (item.processingState === 2) {
            arr.push(item.waybillNumber);
          }
        });

        if (arr.length === 0) {
          this.$message.warning(this.$t('driver.tip0327')); // 仅已闭环状态的才可修改
          return;
        }
        this.modifyingResult.selectedNum = arr.length;
        this.modifyingResultDialog = true;
      } else {
        this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
      }
    },
    submitModifyingResult(type) {
      if (type === 1) {
        this.modifyingResult.updateProcessingResult = '';
        this.modifyingResult.updateType = 0;
        this.fixList = [
          { label: this.$t('GlobalSetObj.Pending'), value: 0 }, // 待处理
          { label: this.$t('newOrder.processing'), value: 1 }, // 处理中
          { label: this.$t('collectionCenter.closedLoop'), value: 2 }, // 已闭环
          { label: this.$t('collectionCenter.cancelled'), value: 3 } // 已取消
        ];
        this.modifyingResultDialog = false;
      } else {
        if (this.modifyingResult.updateProcessingResult !== '') {
          const data = {
            idList: [],
            updateType: this.modifyingResult.updateType,
            updateProcessingResult: this.modifyingResult.updateProcessingResult
          };
          this.selectData.forEach((item) => {
            if (item.processingState === 2) {
              data.idList.push(item.id);
            }
          });
          console.log(data, 'data', this.modifyingResult.updateProcessingResult);
          updateResult(data).then((res) => {
            this.modifyingResultDialog = false;
            if (res.code === 200) {
              this.tipObj = res.data;
              this.tipDialog = true;
              this.getSearch();
              this.modifyingResult.updateProcessingResult = '';
              this.modifyingResult.updateType = 0;
              this.fixList = [
                { label: this.$t('GlobalSetObj.Pending'), value: 0 }, // 待处理
                { label: this.$t('newOrder.processing'), value: 1 }, // 处理中
                { label: this.$t('collectionCenter.closedLoop'), value: 2 }, // 已闭环
                { label: this.$t('collectionCenter.cancelled'), value: 3 } // 已取消
              ];
            }
          });
        } else {
          this.$message.error(this.$t('home.selectDropdownData'));
        }
      }
    },
    // 点击修改截止时间
    clickDeadline() {
      if (this.selectData.length) {
        const arr = [];
        this.selectData.forEach((item) => {
          if (item.processingState !== 2) {
            arr.push(item.waybillNumber);
          }
        });
        if (arr.length === 0) {
          this.$message.warning(this.$t('home.noOperator'));
          return;
        }
        this.time02 = '';
        this.time01 = '';
        this.changeDeadline = true;
      } else {
        this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
      }
    },
    // 点击确定修改截止时间
    confirmUpdataDeadline() {
      if (this.time01 && this.time02) {
        console.log(this.time01, this.time02, 'updateDeadline');
        const data = {
          idList: [],
          abortTime: this.time01 + ' ' + this.time02
        };
        this.selectData.forEach((item) => {
          if (item.processingState !== 2) {
            data.idList.push(item.id);
          }
        });
        updateDeadline(data).then((res) => {
          if (res.code === 200) {
            this.changeDeadline = false;
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // 操作成功
            this.getSearch();
          }
        });
      } else {
        this.$message.warning(this.$t('home.stopTime'));
      }
    },
    // 导出图片
    exportOrderImage() {
      this.$refs.exportImageRef.handleOpen();
    },
    // 批量导出单号
    orderNumberExport() {
      this.$refs.exportOrderNumberRef.handleOpen();
    },
    // 数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 打开关闭弹窗
    closeOrder(row) {
      console.log(row, 'rowrow');
      const resultList = [
        { label: $i18n.t('GlobalSetObj.blameless'), value: 1 },
        { label: $i18n.t('compensationManagement.FalseSigningForDelivery'), value: 0 },
        // 需求：应客服部要求，关闭按钮去掉【全部丢失】的选项。
        // { label: $i18n.t('compensationManagement.lossOfAll'), value: 2 },
        { label: $i18n.t('compensationManagement.PartiallyLost'), value: 3 },
        { label: $i18n.t('home.goodsNOfuhe'), value: 5 },
        { label: $i18n.t('home.infoError'), value: 6 },
        { label: $i18n.t('home.moreTimeNotReply'), value: 7 },
        { label: $i18n.t('tablePrice.invalidResponse'), value: 8 },
        { label: $i18n.t('tablePrice.confirmedLost'), value: 10 }
      ];
      if (!row) {
        if (this.selectData.length === 0) {
          this.$message.warning(this.$t('GlobalSetObj.CheckForm'));
          return;
        }
        if (this.selectData.length > 0) {
          const arr = [];
          this.selectData.forEach((item) => {
            if (item.processingState !== 2 && item.processingState !== 3) {
              arr.push(item.waybillNumber);
            }
          });
          if (arr.length === 0) {
            this.$message.warning(this.$t('home.noOperator')); // 选择的订单状态不可操作
            return;
          }
          const arr1 = [];
          const arr2 = [];
          const arr3 = [];
          this.selectData.forEach((item) => {
            if (item.workOrderType === 0) {
              arr1.push(item.workOrderType);
            } else {
              if ([2, 3].includes(item.workOrderType)) {
                arr3.push(item.workOrderType);
              } else {
                arr2.push(item.workOrderType);
              }
            }
          });
          if (
            (arr1.length > 0 && arr3.length > 0) ||
            (arr2.length > 0 && arr3.length > 0) ||
            (arr1.length > 0 && arr2.length > 0)
          ) {
            this.$message.warning(this.$t('home.selectSameComplaintType'));
            return;
          }
          if (arr1.length > 0) {
            this.processingResultList01 = [
              { label: this.$t('GlobalSetObj.blameless'), value: 1 },
              { label: this.$t('tablePrice.confirmedLost'), value: 10 },
              { label: this.$t('tablePrice.invalidResponse'), value: 8 }
            ];
          } else if (arr3.length > 0) {
            this.processingResultList01 = [
              { label: this.$t('compensationManagement.established'), value: 12 },
              { label: this.$t('compensationManagement.notEstablished'), value: 13 }
            ];
          } else {
            this.processingResultList01 = resultList;
          }
        }
      }
      if (row) {
        this.closeData = [row.id];
        this.$refs.tableRef.clearSelection();
        if (row.workOrderType === 0) {
          this.processingResultList01 = [
            { label: this.$t('GlobalSetObj.blameless'), value: 1 },
            { label: this.$t('tablePrice.confirmedLost'), value: 10 },
            { label: this.$t('tablePrice.invalidResponse'), value: 8 }
          ];
        } else if ([2, 3].includes(row.workOrderType)) {
          this.processingResultList01 = [
            { label: this.$t('compensationManagement.established'), value: 12 },
            { label: this.$t('compensationManagement.notEstablished'), value: 13 }
          ];
        } else {
          this.processingResultList01 = resultList;
        }
      } else {
        this.closeData = [];
        this.selectData.forEach((item) => {
          if (item.processingState !== 2 && item.processingState !== 3) {
            this.closeData.push(item.id);
          }
        });
      }
      this.closeReturn.selectedNum = this.closeData.length;
      this.closeReturn.showCloseComplaints = true;
    },
    // 处理结果确认、取消
    closeReturnSubmit(type) {
      if (type === 1) {
        this.closeReturn.processingResult = null;
        this.closeReturn.showCloseComplaints = false;
      } else {
        this.$refs.closeReturn.validate((valid) => {
          if (valid) {
            console.log(this.closeData, '===this.tableData');
            const paramData = {
              pageNumber: this.queryForm.pageNumber,
              pageSize: this.queryForm.pageSize,
              params: {
                idList: this.closeData,
                processingState: this.closeReturn.processingResult
              }
            };
            console.log(paramData, '===paramData');
            this.closeReturn.processingResult = null;
            this.closeReturn.showCloseComplaints = false;
            apiGetComplaintWorkCloseWork(paramData).then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // 操作成功
                this.getSearch();
                this.closeReturn.processingResult = null;
                this.closeReturn.showCloseComplaints = false;
              }
            });
          }
        });
      }
    },
    // 打开批量导入弹窗
    allImportOrder() {
      this.importForm.messageRemrkDialog = true;
    },
    // 批量导入、关闭弹窗
    messageRemarkSubmit(val) {
      if (val === 1) {
        this.importForm = {
          messageRemrkDialog: false,
          importNumberType: 0,
          importNumber: '',
          complaintType: 0,
          workOrderType: '',
          siteType: 1
        };
      } else {
        this.$refs.importForm.validate((valid) => {
          if (valid) {
            const orderNum = this.importForm.importNumber.split(/[,\n\r，]/); // /[(\r\n)\r\n]+/
            const orderNumArr = [];
            for (let j = 0; j < orderNum.length; j++) {
              const orderNumber = orderNum[j].replace(/\s+/g, '');
              if (orderNumber !== '') {
                if (orderNumArr.indexOf(orderNumber) === -1) {
                  orderNumArr.push(orderNumber.trim());
                }
              }
            }
            const params = {
              orderType: this.importForm.importNumberType,
              complaintType: this.importForm.complaintType,
              workOrderType: this.importForm.workOrderType,
              waybillNumberList: orderNumArr,
              siteType: this.importForm.siteType
            };
            if (this.importForm.workOrderType !== 1) {
              params.complaintType = null;
            } else {
              params.complaintType = this.importForm.complaintType;
            }
            apiGetComplaintWorkOrderImport(params).then((res) => {
              if (res.code === 200) {
                if (res.data && res.data.failNumber > 0) {
                  this.resultData = {
                    showImportResults: true,
                    all: res.data.totalNumber,
                    success: res.data.succeedNumber,
                    err: res.data.failNumber,
                    errData: res.data.failMap
                  };
                } else {
                  this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                }
                this.importForm = {
                  messageRemrkDialog: false,
                  importNumberType: 0,
                  importNumber: '',
                  complaintType: 0,
                  workOrderType: '',
                  siteType: 1
                };
                this.enterSearch();
              }
            });
          }
        });
      }
    },
    // 点击回复弹框
    replyMessage(row) {
      this.seeDialogVisible = true;
      this.replyMessageData = row;
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        waybillNumberList: [], // 运单号
        scanNumberList: [], // 扫描单号
        numberType: 0, // 单号类型: 0-运单号, 1-扫描单号
        timeType: 1, // 时间类型: 1-登记时间, 2-最新回复时间
        testData: 1 // 1:正式 2:测试
      };
      this.returnWaybillNumber = '';
      this.searchParams = {
        workOrderType: null,
        customerName: [],
        registerUserName: [],
        processingStateList: [], // 状态: 1-待处理 2-处理中 3-已闭环
        processingResult: [], // 处理结果: 0.虚假签收，1.无责 2.全部丢失 3.部分丢失
        customerId: [], // 客户名称
        merchantName: [], // 商户名称
        istimeOut: null, // 是否超时: 1-是, 2-否
        complaintType: null,
        state: [], // 网点所属州
        siteName: [], // 网点名称
        registerUserId: [] // 登记人id
      };
      this.tipSearch = {
        status: '',
        result: '',
        istimeOut: '',
        customerName: '',
        merchantName: '',
        stateName: '',
        siteName: '',
        registerUserName: '',
        complaintTypeName: '',
        workOrderTypeName: ''
      };
      this.getSearch();
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch(this.activeName);
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch(this.activeName);
    },
    closeDrawer() {
      console.log(this.intervalTime, ' this.intervalTime');
      clearInterval(this.$refs.messageDetail.getIntervalMsg);
      this.getSearch(this.activeName);
    },
    closeDialog() {
      this.importForm = {
        messageRemrkDialog: false,
        importNumberType: 0,
        importNumber: '',
        complaintType: 0,
        workOrderType: '',
        siteType: 1
      };
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.el-form--label-top ::v-deep .el-form-item__label {
  width: 100% !important;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.conditionListitme {
  position: relative;
  padding: 10px;
  background-color: #d6d6d6;
  margin-bottom: 10px;
}

.demo-drawercontent {
  padding: 0 20px;
  height: calc(100vh - 130px);
  overflow: auto;
}

.delFillter {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.demo-drawer__footer {
  width: 100%;
  border-top: 1px solid #cccccc;
  position: absolute;
  display: flex;
  justify-content: right;
  padding: 10px;
  right: 10px;
  bottom: 0;
  background-color: white;
}

.textOperator {
  color: #409eff;
  font-size: 22px;
  cursor: pointer;
}

.textOperator1 {
  color: #409eff;
  cursor: pointer;
}

.textOperator2 {
  margin-top: -5px;
  color: #409eff;
  font-size: 22px;
  cursor: pointer;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;

  .selfMessage {
    text-align: right;
    margin-bottom: 15px;

    .pepole {
      color: #409eff;
    }

    .pepoleMessage {
      text-align: left;
      display: inline-block;
      padding: 10px;
      background-color: #e2ecf6;
      border: 1px solid #409eff;
      border-radius: 7px;
      max-width: calc(70% - 20px); /* 减去padding和可能的margin值 */
      word-wrap: break-word; /* 允许长单词换行 */
    }
  }

  .otherMessage {
    text-align: left;
    margin-bottom: 15px;

    .pepole {
      color: #409eff;
    }

    .pepoleMessage {
      text-align: left;
      display: inline-block;
      padding: 10px;
      background-color: #ffffff;
      border: 1px solid #cccccc;
      border-radius: 7px;
      max-width: calc(70% - 20px); /* 减去padding和可能的margin值 */
      word-wrap: break-word; /* 允许长单词换行 */
    }
  }
}
</style>
<style>
.tableImg p {
  margin: 0;
  max-height: 180px;
  overflow: hidden;
}

.tableImg img {
  display: none;
}
</style>
